import { TCarbonProjectData } from "../../../types";
// import Button from "../../../components/Button";
import React from "react";
import { Badge } from "../../../components/Badge";
import { Link } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";

interface CurrentProjectGridProps {
  carbonProjects: TCarbonProjectData[];
}

export const CurrentProjectGrid = ({ carbonProjects }: CurrentProjectGridProps) => {
  return (
    <>
      {carbonProjects.map((item) => (
        // <div className="">
        <div
          data-testid={`${item.properties.id}`}
          key={`${item.properties.id}`}
          className="flex w-full flex-col justify-center gap-2 rounded-lg bg-white p-4 shadow-md"
        >
          <div className="flex items-center justify-between">
            <h4 className="basis-[90%] font-semibold text-primaryPurple-100">
              {item.properties.name}
              <span className="font-light text-gray-500">
                &nbsp;| ID: #{item.properties.project_id}
              </span>
            </h4>
            <BsThreeDotsVertical className="text-primaryPurple-100" />
          </div>

          <p
            className={"truncate border-gray-300 pb-4 font-normal text-[#231F20CC]"}
            style={{ borderBottomWidth: "1px" }}
          >
            {item.properties.description}
          </p>

          <div className="mt-2 flex items-center justify-between">
            <Badge>{item.properties.status}</Badge>
            <Link to={`/project/${item.properties.id}`}>
              {/* <Button variant="outlined" className="hover:bg-gray-300"> */}
              <button className="cursor-pointer rounded-md border border-primaryPurple-100 bg-white px-4 py-2 text-sm font-normal text-primaryPurple-100 outline-none transition-all duration-200 hover:bg-purple-50">
                More details
              </button>
              {/* </Button> */}
            </Link>
          </div>
        </div>
        // </div>
      ))}
    </>
  );
};
